import React from 'react';
import classNames from 'classnames';
import { components } from 'react-select';
import PropTypes from 'prop-types';

const Control = (props) => {
  const {
    selectProps: { invalid, isTouchDevice, iconComponent, prefixTextComponent },
  } = props;
  const { children, ...restProps } = props;
  const classes = classNames({
    'ws-ui-base-select__control--is-invalid': invalid,
    'ws-ui-base-select__control--is-touch-device': isTouchDevice,
  });

  return (
    <components.Control {...restProps} className={classes}>
      {iconComponent}
      {prefixTextComponent}
      {children}
    </components.Control>
  );
};

Control.propTypes = {
  children: PropTypes.node.isRequired,
  selectProps: PropTypes.shape({
    invalid: PropTypes.bool,
    isTouchDevice: PropTypes.bool,
    iconComponent: PropTypes.element,
    prefixTextComponent: PropTypes.element,
  }).isRequired,
};

export default Control;
